import { Routes, Route, Navigate } from 'react-router-dom'
import { Layout } from '@/components/Layout'
// import { DemoPage } from '@/pages/DemoPage'
import { AboutPage } from '@/pages/AboutPage'
// import { PlaygroundPage } from '@/pages/PlaygroundPage'
import { TransitionEditorPage } from '@/pages/TransitionEditorPage'
import { DocumentPage } from '@/pages/DocumentPage'
import { DocumentDetailPage } from '@/pages/DocumentDetailPage'
// import { MidiControllerPage } from '@/pages/MidiControllerPage'
import { MusicVisualizerPage } from '@/pages/MusicVisualizerPage'

import { PlaylistQueuesPage } from '@/pages/PlaylistQueuesPage'
import { MixPlayerPage } from '@/pages/MixPlayerPage'
import { LogComparisonPage } from '@/pages/LogComparisonPage'
import { RealMixPage } from '@/pages/RealMixPage'

import { AuthPage } from '@/pages/AuthPage'
import { EvaluationPage } from '@/pages/EvaluationPage'
import { EvaluationTaskPage } from '@/pages/EvaluationTaskPage'
import { ProtectedRoute } from '@/components/ProtectedRoute'
import { BlogPage } from '@/pages/BlogPage'
import { BlogDetailPage } from '@/pages/BlogDetailPage'

function App() {
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Navigate to="/visualizer" replace />} />
        {/* <Route path="/demo" element={<DemoPage />} /> */}
        <Route path="/visualizer" element={<MusicVisualizerPage />} />
        {/* 暂时屏蔽 Playground / MIDI Controller */}
        <Route path="/playground" element={<Navigate to="/visualizer" replace />} />
        <Route path="/transition-editor" element={<TransitionEditorPage />} />
        <Route path="/midi-controller" element={<Navigate to="/visualizer" replace />} />
        <Route path="/realmix" element={<RealMixPage />} />
        <Route path="/blog" element={<BlogPage />} />
        <Route path="/blog/:id" element={<BlogDetailPage />} />
        <Route path="/document" element={<DocumentPage />} />
        <Route path="/document/:id" element={<DocumentDetailPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/experiments/:instance" element={<PlaylistQueuesPage />} />
        <Route path="/experiments/:instance/:queue" element={<MixPlayerPage />} />
        <Route path="/experiments/:instance/:queue/:pairIndex" element={<MixPlayerPage />} />
        <Route path="/experiments/:instance/:queue/:pairIndex/compare" element={<LogComparisonPage />} />
        
        {/* 认证和评估路由 */}
        <Route path="/auth" element={<AuthPage />} />
        <Route 
          path="/evaluation" 
          element={
            <ProtectedRoute>
              <EvaluationPage />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/evaluation/:instanceId/task/:taskId" 
          element={
            <ProtectedRoute>
              <EvaluationTaskPage />
            </ProtectedRoute>
          } 
        />
      </Routes>
    </Layout>
  )
}

export default App
